// extracted by mini-css-extract-plugin
module.exports = {"content":"Transfer_content__sBiSu","alert":"Transfer_alert__153yx"};